const state = {
  appId: 'wxab621016d24c7c35',
  wxCode: null,
  userInfo: null,
  isApp: null,
  // 终端类型: 1=PC, 2=H5, 3=iOS, 4=Android, 5=MiniProgram
  terminal: null,
  phoneNumber: null,
  // 支付状态 success/fail
  payState: null,
  // 全城热浪号/邀请码
  dayulongNumber: null,
  isWeChatBind: null,
  isCertification: null,
}

const mutations = {
  setWxCode(state, wxCode) {
    state.wxCode = wxCode
  },
  setUserInfo(state, userInfo) {
    state.userInfo = userInfo
  },
  setIsApp(state, isApp) {
    state.isApp = isApp
  },
  setTerminal(state, terminal) {
    state.terminal = terminal
  },
  setPhoneNumber(state, phoneNumber) {
    state.phoneNumber = phoneNumber
  },
  setPayState(state, payState) {
    state.payState = payState
  },
  setDayulongNumber(state, dayulongNumber) {
    state.dayulongNumber = dayulongNumber
  },
  setIsWeChatBind(state, isWeChatBind) {
    state.isWeChatBind = isWeChatBind
  },
  setIsCertification(state, isCertification) {
    state.isCertification = isCertification
  },
}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
